// 配置信息

import mutations from './mutations'
import actions from './actions/index'
import getters from './getters/index'
import { isArray } from '../../../utils/base'

// 基础配置
// const wxConfig = window._wzConfig_ || {}

const wzWebConfig = window._wzWebConfig_ || {}

let { baseConf, cIds, awardMap } = wzWebConfig

// 基本配置

// 比赛配置
cIds = isArray(cIds) ? cIds : []

const state = {
  baseConf: baseConf || null,
  cIds,
  awardMap,
  matchConfigs: null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
